<script>
	import { PUBLIC_PATH } from '$env/static/public';
	export let lspPartnersData;
</script>

<section
	id="lsp_partners"
	aria-label="LSP Partners"
	class="z-10 w-full overflow-hidden bg-tint12-primary px-[3.875rem] py-padding_xsm lg:py-8"
>
	<div class="mx-auto max-w-8xl">
		<div class="flex flex-col items-center rounded-shape-corner_lg">
			<div class="flex w-full items-center justify-center gap-3 lg:gap-8 lg:px-[7.5rem]">
				<div class="flex shrink-0 items-center justify-center">
					<h2
						class="whitespace-nowrap text-center text-[1.1875rem] font-semibold leading-[1.5rem] text-backdrop lg:text-[1.75rem] lg:font-medium lg:leading-[2rem] lg:tracking-[0.00625rem]"
					>
						{lspPartnersData.title}
					</h2>
				</div>

				{#each lspPartnersData.logos as logo}
					<div class="flex shrink-0 flex-col items-center justify-center">
						<div class="flex w-[6.6875rem] items-center justify-center lg:w-auto">
							<img
								class="h-10 w-auto max-w-20 object-contain"
								src={`${PUBLIC_PATH}/${logo.src}`}
								alt={logo.altText}
							/>
						</div>
					</div>
				{/each}
			</div>
		</div>
	</div>
</section>
